import { Input } from "@progress/kendo-react-inputs";
import { PanelBar, PanelBarItem, Splitter } from "@progress/kendo-react-layout";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { List } from "../../../components/list";
import {
  Button,
  DropDownButton,
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
} from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { Form } from "../../../components/form";
import { setEntityFilter } from "../../../redux/slices/scheduleviewpageslice";
import { useDispatch } from "react-redux";
import {
  canAccessSchedule,
  canCreateSchedule,
  canDeleteSchedule,
  canEditSchedule,
  scheduleMaxReached,
} from "../../../routing/authorizationhandlers";
import { useTranslation } from "react-i18next";
import { ScheduleViewPageForm } from "./scheduleviewpageform";

const toolbarRenderer = (props) => {
  const { currentTheme, currentUser, pageState, t } = props;

  const toolsVisibleIcon = pageState.toolsVisible ? "unpin" : "pin";
  const toolsVisibleTitle = pageState.toolsVisible
    ? t("datasets.datasetview.hide")
    : t("datasets.datasetview.show");

  const saveTitle = t("schedule.updateschedule");

  return (
    <Toolbar>
      <ToolbarItem>
        <Button
          disabled={pageState.processing}
          style={{ color: currentTheme.primary }}
          icon={toolsVisibleIcon}
          onClick={props.onToolsToggle}
        >
          {toolsVisibleTitle}
        </Button>
      </ToolbarItem>
      <ToolbarSeparator />
      {currentUser.IsAuthenticated && canCreateSchedule && (
        <ToolbarItem>
          <Button
            //disabled={pageState.processing || scheduleMaxReached}
            style={{ color: currentTheme.primary }}
            icon="plus"
            onClick={props.onNew}
          >
            {t("schedule.createschedule")}
          </Button>
        </ToolbarItem>
      )}
      {currentUser.IsAuthenticated && canEditSchedule && (
        <Fragment>
          <ToolbarSeparator />
          <ToolbarItem>
            <Button
              disabled={
                pageState.processing ||
                (pageState.mode == 1 && scheduleMaxReached)
              }
              style={{ color: currentTheme.primary }}
              icon="save"
              onClick={props.onSave}
            >
              {saveTitle}
            </Button>
          </ToolbarItem>
        </Fragment>
      )}

      {currentUser.IsAuthenticated && canDeleteSchedule && (
        <Fragment>
          <ToolbarSeparator />
          <ToolbarItem>
            <Button
              disabled={pageState.processing}
              style={{ color: currentTheme.primary }}
              icon="delete"
              onClick={(e) => props.onDelete(pageState.formValues.Id)}
            >
              {t("schedule.deleteschedule")}
            </Button>
          </ToolbarItem>
        </Fragment>
      )}

      <ToolbarSeparator />
      <ToolbarItem>
        <Button
          disabled={pageState.processing}
          style={{ color: currentTheme.primary }}
          title={
            pageState.formValues.IsActive ? "pause schedule" : "resume schedule"
          }
          icon={pageState.formValues.IsActive ? "pause" : "play"}
          onClick={(e) => {
            pageState.formValues.IsActive
              ? props.onPauseSchedule(
                  Number(pageState.formValues.Id),
                  pageState.formValues.importexport,
                )
              : props.onResumeSchedule(
                  Number(pageState.formValues.Id),
                  pageState.formValues.importexport,
                );
          }}
        ></Button>
      </ToolbarItem>
    </Toolbar>
  );
};

const getEntityOperations = (entity, currentUser, t) => {
  let result = [];

  if (currentUser.IsAuthenticated && (canAccessSchedule || canEditSchedule))
    result.push({ id: 2, text: t("datasets.datasetview.view"), icon: "eye" });

  if (currentUser.IsAuthenticated && entity.Modules == 0 && canDeleteSchedule)
    result.push({
      id: 3,
      text: t("datasets.datasetview.delete2"),
      icon: "delete",
    });

  return result;
};

const entityMenuItemRenderer =
  (currentTheme, entity, onItemClicked) => (props) => {
    let isDisabled = false;
    if (
      props.item.id == 3 &&
      (entity.IsFederationRoot || entity?.IsRootSubscription)
    )
      isDisabled = true;

    if (props.item.text)
      return (
        <div
          style={{ display: "flex", width: "100%", padding: "0px 6px" }}
          onClick={(e) => onItemClicked(entity.Id, props.item)}
        >
          <span
            className={`k-icon k-i-${props.item.icon}`}
            style={{ display: "inline-block" }}
          ></span>
          <div style={{ marginLeft: 12 }}>{props.item.text}</div>
        </div>
      );
    else return <div className="menu-separator" style={{}} />;
  };

const entitiesItemRenderer =
  (currentTheme, currentUser, system, t) => (props, item, index) => {
    let icon = "k-i-data";
    return (
      <div
        key={item.Id}
        importexport={item.importexport}
        className={`list-item`}
        style={{
          color: currentTheme.bodyText,
        }}
        onDoubleClick={(e) => props.onEntityDoubleClick(item.Id,item.importexport)}
      >
        <div className={`list-item-icon k-icon ${icon} `}></div>
        <div className="list-item-title">{item.Name}</div>
        {currentUser.IsAuthenticated &&
          (canAccessSchedule || canEditSchedule || canDeleteSchedule) && (
            <div className="list-item-operations">
              <DropDownButton
                className="buttons-container-button"
                items={getEntityOperations(item, currentUser, t)}
                itemRender={entityMenuItemRenderer(
                  currentTheme,
                  item,
                  (entityId, _item) => {
                    if (_item.id == 1 || _item.id == 2) {
                      debugger;
                      //view
                      props.onEntitySelected(entityId, item.importexport);
                    } else if (_item.id == 3)
                      // delete
                      props.onDelete(entityId, _item);
                  },
                )}
                icon="more-horizontal"
                fillMode={"flat"}
              />
            </div>
          )}
      </div>
    );
  };

export const ScheduleViewPageBody = (props) => {
  const {
    onSplitterChange,
    onClose,
    onChangeFormValue,
    onNew,
    onSave,
    onActivateDeactivate,
    onDelete,
    onPauseSchedule,
    onResumeSchedule,
    onErrorbarClose,
    onEntitySelected,
    onEntityDoubleClick,
    updateDirtyState,
    onToolsToggle,
    onRecurrencyOptionChange,
    loadGoogleConnectorSheets,
    loadGoogleConnections,
    getGoogleSheetId,
    onKeyChange,
    loadDatasets,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const currentUser = useSelector((state) => state.currentUser);
  const pageState = useSelector((state) => state.scheduleViewPage);
  const appearance = useSelector((state) => state.appearance);
  const dispatch = useDispatch();
  const entities = pageState.entities;
  const { t } = useTranslation();

  const getPanelBarItems = () => {
    const panelBarItems = [];
    panelBarItems.push(
      <PanelBarItem
        className="panel-user-defined-entities"
        key="userentities"
        title={t("schedule.schedule")}
        expanded={true}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Input
            type="search"
            value={pageState.entityFilter}
            onChange={(e) => dispatch(setEntityFilter(e.value))}
            style={{
              width: "calc(100% - 16px)",
              margin: "8px 8px 8px 8px",
              backgroundColor: "transparent",
            }}
            placeholder={t("datasets.datasetview.search")}
          />
          <List
            className="entities"
            items={entities?.filter((e) => {
              if (
                !pageState.entityFilter ||
                pageState.entityFilter?.trim() == ""
              )
                return true;

              const filter = pageState.entityFilter?.toLowerCase();
              return e?.Name?.toLowerCase().indexOf(filter) >= 0;
            })}
            itemRenderer={entitiesItemRenderer(
              currentTheme,
              currentUser,
              false,
              t,
            )}
            onEntitySelected={props.onEntitySelected}
            onEntityDoubleClick={props.onEntityDoubleClick}
            onDelete={props.onDelete}
          />
        </div>
      </PanelBarItem>,
    );
    return panelBarItems;
  };

  return (
    <Fragment>
      {pageState.processing && (
        <div className="page-loader">
          <Loader
            size={"large"}
            type="infinite-spinner"
            themeColor={"primary"}
          />
          {pageState.processingText && (
            <div style={{ fontSize: 13, color: currentTheme.primary }}>
              {pageState.processingText}
            </div>
          )}
        </div>
      )}
      {pageState.pageLoaded && (
        <Splitter
          style={{ border: "none" }}
          panes={pageState.panes}
          onChange={onSplitterChange}
        >
          <div className="scheduleView-page-manager">
            <PanelBar style={{ border: "none" }} expanded={[".0", ".1"]}>
              {getPanelBarItems()}
            </PanelBar>
          </div>
          <div className={`right datasetview-page-wrapper`}>
            <div className="scheduleview-mobile-close">
              <Button
                icon={appearance.isRightToLeft ? "arrow-right" : "arrow-left"}
                fillMode="flat"
                title={t("currentuser.back")}
                aria-label={t("currentuser.back")}
                onClick={onClose}
              >
                {t("currentuser.back")}
              </Button>
            </div>
            <Form
              className="scheduleview-page-form"
              currentTheme={currentTheme}
              currentUser={currentUser}
              toolbarRenderer={toolbarRenderer}
              t={t}
              onNew={onNew}
              onToolsToggle={onToolsToggle}
              onSave={onSave}
              onActivateDeactivate={onActivateDeactivate}
              onDelete={onDelete}
              onPauseSchedule={onPauseSchedule}
              onResumeSchedule={onResumeSchedule}
              errorMessages={pageState.formServerErrors}
              onErrorbarClose={onErrorbarClose}
              onRecurrencyOptionChange={onRecurrencyOptionChange}
              onKeyChange={onKeyChange}
              loadDatasets={loadDatasets}
              pageState={pageState}
            >
              <ScheduleViewPageForm
                updateDirtyState={updateDirtyState}
                onRecurrencyOptionChange={onRecurrencyOptionChange}
                loadGoogleConnectorSheets={loadGoogleConnectorSheets}
                loadGoogleConnections={loadGoogleConnections}
                getGoogleSheetId={getGoogleSheetId}
                onChangeFormValue={onChangeFormValue}
                loadDatasets={loadDatasets}
                onKeyChange={onKeyChange}
              />
            </Form>
          </div>
        </Splitter>
      )}
      <style>
        {`
                   .scheduleView-page > .content
                   {
                   } 
   
                    .scheduleView-page .k-splitter{
                      flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }
                      
                    .scheduleView-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                    .scheduleView-page .datasetview-page-wrapper{
                    border: ${currentTheme.pageFormBorder};   
                    height:100%; direction:${
                      appearance.isRightToLeft ? "rtl" : "ltr"
                    }
                    }

                    .scheduleView-page .scheduleview-mobile-close {
                      display: none;
                    }
                   
                    /*the manager*/
                    .scheduleView-page > .content .scheduleView-page-manager
                    {
                      border: ${currentTheme.managerBorder};
                      border-radius: ${currentTheme.pageBorderRadius};
                      background-color: ${currentTheme.componentBgFaded};
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .k-dropdownlist
                    {
                      /*bg of datasets dropdown*/
                      background-color: transparent;
                      color: ${currentTheme.componentText};
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .k-dropdownlist:focus
                    {
                        box-shadow: none;   
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .panel-entities .k-input::placeholder
                    {
                        color: ${currentTheme.componentText};
                        /*font-style: italic;*/
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .k-panelbar
                    {
                      background-color: transparent;
                    }

                    .scheduleView-page > .content .expressions-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link .k-icon
                    {
                      /*the arrow near every panel header*/
                      color: ${currentTheme.touchColor}!important;
                      margin-right: 6px;
                    }

                    .scheduleView-page .scheduleView-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link
                    {
                      /*the span in the above <li> i.e. the title of every group in the manager: datasets, scheduleView, columns and description*/  
                      background-color: transparent;
                      color: ${currentTheme.touchColor};
                      border-bottom: 1px solid ${currentTheme.separatorColor}; 
                    }

                    .scheduleView-page .scheduleView-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link:hover
                    {
                      /*the above hovered - do nothing*/
                    }

                    .scheduleView-page .scheduleView-page-manager .scheduleView .list-item:hover
                    {
                      /*expression item hover */
                      background-color: ${currentTheme.componentBorderColor};
                      cursor: pointer;
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .dataset,
                    .scheduleView-page > .content .scheduleView-page-manager .description,
                    .scheduleView-page > .content .scheduleView-page-manager .k-child-animation-container
                    {
                      /*bg color of exp. manager elements */
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .list-container
                    {
                      /*bg of both the exp. and columns Lists*/
                      background-color: transparent;
                      padding: 0;
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .k-panelbar-header
                    {
                      background-color: transparent;
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .k-panelbar-content
                    {
                      background-color: transparent;
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .scheduleView .list-item-datasource-icon
                    {
                      /*first icon in scheduleView list*/
                      padding-left: 12px!important;
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .scheduleView .list-item-datasource-icon
                    {
                      /*second icon in data sources list*/
                      padding: 5px 3px;                 
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .scheduleView .list-item-title
                    {
                      vertical-align: middle;/*fine tuning*/
                    }               


                    /*the form*/
                    .scheduleView-page-form
                    {
                      background-color: transparent;
                      padding-left: 0px;
                      border: ${currentTheme.pageFormBorder};   
                      border-radius: ${currentTheme.pageBorderRadius};
                    }   

                    /*form toolbar*/
                    .scheduleView-page-form > .toolbar .k-toolbar
                    {
                        width: 100%;
                        border-left: none !important;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                        border-top: none !important;
                        border-right: none !important;
                        background-color: ${
                          currentTheme.toolbarBg
                        };/*transparent;*/
                    }                    

                    .scheduleView-page > .content .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                    }

                    .scheduleView-page > .content .toolbar .k-button-text
                    {
                      /*color of the text in every toolbar button=black in azure theme*/
                      color: ${currentTheme.toolbarText};
                    }

                    .scheduleView-page > .content .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.primary};
                    }

                    .scheduleView-page > .content .form-root .content
                    {
                      background-color: ${currentTheme.pageContentBg};
                    }

                    /*styling the popup menu */
                    .k-popup ul{
                        padding: 0px;
                    }

                    .k-popup ul > li{
                        margin: 0;
                        padding: 0px;                                
                    }

                    .k-popup ul > li > span{
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .k-menu-link{
                        padding: 0px 0px !important;                        
                    }

                    .k-tabstrip-items .k-link {
                        color:${currentTheme.primary}
                    }

                    .k-tabstrip-items .k-item.k-active .k-link {
                        color:${currentTheme.touchColor}
                    }
                    .k-panelbar > .k-item > .k-link:focus{
                        box-shadow:none;
                    }

                    @media (max-width: 1024px) {
                      .scheduleView-page > .content {
                        overflow-y: auto;
                      }

                      .scheduleView-page > .content .k-splitbar,
                      .scheduleView-page > .content .k-splitter > .k-pane:first-child {
                        display: none !important;
                      }

                      .scheduleView-page > .content .k-splitter > .k-pane:last-child {
                        flex: 1 1 100% !important;
                        width: 100% !important;
                        max-width: 100% !important;
                      }

                      .scheduleView-page .datasetview-page-wrapper,
                      .scheduleView-page .scheduleview-page-form {
                        height: auto;
                        min-height: 100%;
                      }

                      .scheduleView-page .datasetview-page-wrapper {
                        box-sizing: border-box;
                        padding-bottom: calc(80px + env(safe-area-inset-bottom));
                      }

                      .scheduleView-page .scheduleview-page-form > .toolbar {
                        display: none;
                      }

                      .scheduleView-page .scheduleview-mobile-close {
                        display: flex;
                        justify-content: ${
                          appearance.isRightToLeft ? "flex-end" : "flex-start"
                        };
                        padding: 0 8px 8px;
                      }
                    }

                    .scheduleView-page > .content .scheduleView-page-manager .k-panelbar-header{
                        border-color:transparent;
                         box-shadow:none;
                    }

                     .k-panelbar > .k-item > .k-link,.k-panelbar > .k-item > .k-link.k-selected:hover, .k-panelbar > .k-panelbar-header > .k-link.k-selected:hover{
                         box-shadow:none;
                    }
                  `}
      </style>
    </Fragment>
  );
};
